import { Component, Input } from '@angular/core';
import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  selector: 'soft-field-ok-verkaufsartwerkstatt-list-view',
  imports: [],
  templateUrl: './verkaufsartwerkstatt.list-view.html',
  styleUrls: ['./verkaufsartwerkstatt.list-view.css'],
})
export class VerkaufsartwerkstattListView implements FieldOkItemComponent<any> {
  @Input() item: any;
}
